<template>
	<div class="">
	<div class="header-page">
    <div class="header-content" @touchmove.prevent>
        <div class="pt10 disflex" style="justify-content: center;background:url(static/images/star.png) no-repeat center -70px;max-width:750px;height: 380px;background-size: cover;align-items: flex-start;">
          <a class="logo" style="width: 150px;margin: 0 30px;" href="/"><img src="static/images/logo1.png" /></a>
        </div>
    </div>
    <a class="back" href="mytel://back"  style="margin-left: 20px">
      <img width="120" src="../../static/images/back_myid.png" />
    </a>

  </div>
    <div class="disflex por" style="justify-content: space-between;padding:0 20px;margin: 10px 0;z-index: 99;">
      <div class="account-top ar mr10" @click="getMenu"  @click.stop>
        <img width="80" src="static/images/menu.png">
      </div>
      <div class="account-top ar mr10" @click="getAcount()"  @click.stop>
        <img width="80" src="static/images/account-icon2.png" v-if="isShow">
        <img width="80" src="static/images/account-icon.png" v-else>
      </div>
    </div>
    <div class="menu-bg" v-if="isShowMenu"  @click.stop></div>
    <div class="menu-list" v-if="isShowMenu">
      <div class="disflex" style="justify-content: center;padding:40px 0;">
        <a class="logo" style="width: 150px;margin: 0 30px;" href="/"><img src="static/images/logo1.png" /></a>
        <img style="margin-left: 40px;" @click="getMenu" src="../../static/images/re.png" />
      </div>
      <div class="drop-down">
              <div class="drop-down-bottom">
                <div class="meun-i1" @click="getType('winnerList')">
                  <img src="../../static/images/menu-icon1.png" />
                  <div class="down-a">{{$t('winnerList')}}<span class="dian"></span></div>
                </div>
                 <div class="meun-i1" @click="getType('luckyDraw')">
                  <img width="20" src="../../static/images/menu-icon2.png" />
                   <div class="down-a">{{$t('Prize')}}<span class="dian"></span></div>
                 </div>
                <div class="meun-i1" @click="getType('DailyLogin')">
                  <img src="../../static/images/menu-icon0.png" />
                  <div class="down-a">{{$t('DailyLogin')}}<span class="dian"></span></div>
                </div>
                 <div class="meun-i1" @click="getType('referral')">
                  <img src="../../static/images/icon1.png" />
                   <div class="down-a"><span>{{$t('referral')}}</span><span class="dian"></span></div>
                 </div>
                <div class="meun-i1" @click="getType('buyPack')">
                  <img src="../../static/images/menu-icon4.png" />
                  <div class="down-a"><span>{{$t('buyPack')}}</span><span class="dian"></span></div>
                </div>
                <div class="meun-i1" @click="getType('ruleTask')">
                  <img src="../../static/images/menu-icon9.png" />
                  <div class="down-a"><span>{{$t('ruleTask')}}</span><span class="dian"></span></div>
                </div>
                <div class="meun-i1" @click="getType('invitationLog')">
                  <img src="../../static/images/menu-icon8.png" />
                  <div class="down-a"><span>{{$t('invitation_log')}}</span><span class="dian"></span></div>
                </div>
                <div class="meun-i1" @click="getType('personalInfo')">
                  <img src="../../static/images/menu-icon3.png" />
                  <div class="down-a"><span>{{$t('personalInfo')}}</span><span class="dian"></span></div>
                </div>
                <div class="meun-i1" @click="getType('guidance')">
                  <img src="../../static/images/menu-icon6.png" />
                  <div class="down-a">{{$t('Guidance')}}<span class="dian"></span></div>
                </div>
                <div class="meun-i1" @click="getType('faq')">
                  <img src="../../static/images/menu-icon5.png" />
                  <div class="down-a">{{$t('FAQs')}}<span class="dian"></span></div>
                </div>
                <div class="meun-i1" @click="getType('termsAndCondition')">
                  <img src="../../static/images/menu-icon6.png" />
                  <div class="down-a">{{$t('TC')}}<span class="dian"></span></div>
                </div>
               <div class="meun-i1" @click="getType('language')">
                   <img src="../../static/images/menu-icon7.png" />
                  <div class="down-a">{{$t('language')}}<span class="dian"></span></div>
                </div>
                <div class="meun-i1" style="justify-content: center;" @click="unSubscribe('unSubscribe')">
                 <button class="down-a btn mt50" style="font-size: 26px;width: 100%;">{{$t('UNSUBSCRIBE')}}<span class="dian"></span></button>
                  <!-- <button class="down-a">{{$t('logout')}}<span class="dian"></span></button> -->
                </div>
              </div>
            </div>

            <Dialog ref="saveDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
                <div class="alert-modal sub-bg" slot="mdBox" >
                    <div class="sub-content ac">
                      <div class="nav">
                      	<span class="font-family">{{$t('ohNo')}}!</span>
                      </div>
                      <div class="sub-bottom">
                          <div class="sub-t fs33">
                            {{$t('subDes2')}}
                          </div>
                          <div class="sub-t fs20 fw4">
                            {{$t('des2')}}
                          </div>
                          <div class="mt50 disflex" style="justify-content: space-evenly;">
                            <button class="btn-bl fw7" @click="saveModal()">{{$t('Yes')}}</button>
                            <div class="">
                              <button class="btn-yl fw7" @click="closeSubscribe('unSubscribe')">{{$t('No')}}</button>
                            </div>
                          </div>
                      </div>
                    </div>
                </div>
            </Dialog>
    </div>
	</div>
</template>

<script>
    import Dialog from '../components/dialog'
    export default {
        name: 'app-header',
        components:{
          Dialog
        },
        data () {
            return {
              search:'',
              isShow:false,
              isActive:'/',
              isShowMenu:false,
              isLogin:false,
              isEnShow:false,

            }
        },
        mounted() {
          if(this.$route.query.url){
            this.isActive = this.$route.query.url
          }else{
            this.isActive = '/'
          }
          if(localStorage.getItem('token')){
            this.isLogin = true
          }
          document.addEventListener("click", this.bodyCloseMenus);
         },
         beforeDestroy() {
           document.removeEventListener("click", this.bodyCloseMenus);
          },
		methods: {
      getMenu(){
        this.isShowMenu = !this.isShowMenu
        this.$emit('showMenu',this.isShowMenu)
      },
      bodyCloseMenus(e) {
         let self = this;
          if (self.isShow == true){
           self.isShow = false;
          }
        },
			getType(item){
				let that =this;
				this.isActive = item.url;
        this.$router.push({path:item,query:{url:item}});
			},
			getAcount(){
				let that =this;
        this.$router.push({path:'/personalInfo'})
			},
      getShowLogin(){
        this.$router.push({path:'/login'})
      },
      unSubscribe(){
      	//this.isShow = false;
      	this.$refs.saveDialog.showMaskFun();
      },
      closeSubscribe(){
        this.$refs.saveDialog.closeMask();
      },
      // 弹框保存
      saveModal (){
        let that =this;
        that.$parent.$parent.loadModal(true);
        that.$api.post('/api/user/unsubscribe',null,r =>{
        	//that.$parent.returnCode(r,function(){
            that.$utils.alertText(r.msg,80,3000);
            that.$parent.$parent.loadModal(false);
            if(r.code==1){
              localStorage.removeItem('token')
              this.$router.push({path:'/login',query:{}});
            }else{
              this.$refs.saveDialog.closeMask();
            }
          //});
        })
      }
		}
    }
</script>
<style>
  .menu-list{background: url(../../static/images/menu-bg.jpg) no-repeat 0 -100px;width:610px;position: fixed;top: 0;bottom: 0;z-index: 10000;background-size: cover;}
  .menu-bg{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    z-index: 998;
    opacity: 0.5;}
    .meun-i1{display: flex;margin: 20px 40px;    align-items: center;}
    .meun-i1 img{width:30px;margin-right: 30px;}
    .meun-i1 .down-a{width: calc(100% - 40px);font-size:36px}
</style>



// WEBPACK FOOTER //
// src/components/headerNo.vue